import { normalizeString as normalizeId } from "@/utils/stringUtils";

type SelectedIdConfig = {
  selectedIdName?: unknown;
  selectedIdValue?: unknown;
};

export const hasSelectedIdConfig = (
  config?: SelectedIdConfig | null,
): boolean => {
  if (!config?.selectedIdName) return false;
  if (config.selectedIdValue === undefined || config.selectedIdValue === null) {
    return false;
  }
  return `${config.selectedIdValue}`.trim() !== "";
};

export const getNormalizedSelectedId = (
  config?: SelectedIdConfig | null,
): string | undefined => {
  if (!hasSelectedIdConfig(config)) return undefined;
  return normalizeId(config?.selectedIdValue as string);
};

export const hasNormalizedSelectedId = (
  normalizedId: unknown,
): normalizedId is string =>
  typeof normalizedId === "string" && normalizedId.length > 0;
